import React from 'react'
import './featured-footer.scss'
import { useStaticQuery, graphql } from 'gatsby'
import Button from '../../../shared/components/atoms/button/button'
import ModalVideo from '../../../shared/components/modals/modal-video/modal-video'
import EnvironmentalCard from '../../atoms/environmental-card/environmental-card'
import { siteUrl } from '../../../shared/utils/siteUrl'

const FeaturedFooter = props => {
    const { mobile, setModalActive, isLogin } = props;

    const resultQuery = useStaticQuery(
        graphql`
            query PATERN_INFO_FEATURED_FOOTER {
                allContentfulNolHomeTercerNivel(filter: {autopauta1: {elemMatch: {titulo: {eq: "Autopauta > Mis Puntos"}}}}) {
                    edges{
                        node {
                            node_locale
                            autopauta1 {
                                imagenDestacada {
                                    file {
                                        details {
                                            image {
                                                height
                                            }
                                        }
                                        url
                                    }
                                    description
                                    fixed {
                                        base64
                                    }
                                }
                                tituloProductoDestacado1 {
                                    json
                                }
                                subtituloProductoDestacado1 {
                                    json
                                }
                                boton
                                botonRedireccion
                                redireccionVideo
                                titulo
                            }
                        }
                    }
                }
            }
        `
    )


    var contentInfo;
    if (isLogin) {
        contentInfo = resultQuery.allContentfulNolHomeTercerNivel.edges.filter(e => e.node.node_locale === process.env.LOCALE)[1].node.autopauta1[0];
    } else {
        contentInfo = resultQuery.allContentfulNolHomeTercerNivel.edges.filter(e => e.node.node_locale === process.env.LOCALE)[0].node.autopauta1[0];
    }

    const registerRedirect = () => {
        window.location.href = siteUrl + contentInfo.botonRedireccion
    }

    const setModalVideo = e => {
        e.stopPropagation()
        if (mobile) {
            window.location.href = contentInfo.redireccionVideo
        } else {
            setModalActive(<ModalVideo
                activeModal={1}
                identify={1}
                setModalClose={() => setModalActive(null)}
                info={{ node: { codigoVideo: contentInfo.redireccionVideo.split('/')[3] } }}

            />)
        }
    }

    return (
        <>
            <div className="f-featured-footer">
                <div className={"f-release-curve" + (isLogin ? ' f-back-curve-login' : '')} />
                <div className="f-container-mobile">
                    {mobile &&
                        <EnvironmentalCard />
                    }
                    <div className={"f-featured-footer-container" + (isLogin ? ' f-shadow-card-login' : '')}>
                        <a className="f-featured-footer-container-video" href="/">
                            <img
                                className="f-featured-footer-videos-imagen"
                                src={contentInfo.imagenDestacada.file.url}
                                alt={contentInfo.imagenDestacada.description}
                                onClick={e => { e.preventDefault(); setModalVideo(e) }}
                            // src={pageLoad ? info.fields.imagenArticuloPrevisualizacion[0].fields.file.url : info.fields.imagenArticuloPrevisualizacion[0].fields.fixed.base64}
                            />
                        </a>
                        <div className="f-featured-footer-container-info">
                            <p className="f-featured-footer-container-info-tituloProductoDestacado1">{contentInfo.tituloProductoDestacado1.json.content[0].content[0].value}</p>
                            <p className="f-featured-footer-container-info-subtituloProductoDestacado1">{contentInfo.subtituloProductoDestacado1.json.content[0].content[0].value}</p>
                            {!isLogin && <div className="f-featured-footer-container-info-actions" >
                                <Button className="primary-blue short" title={contentInfo.boton} onClick={() => registerRedirect()} />
                            </div>}
                            
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default FeaturedFooter
